import NotificationsBadge from './NotificationsBadge';
export default NotificationsBadge;
